import { httpDelete, httpGet, httpPatch, httpPost } from '../http.service'
import { IHttpResponse } from '../common.interface'

class StaffService {
	async fetchListing(params?: any) {
		return await httpGet<IHttpResponse<any>>('api/v1/admin/staff', params)
	}
	async create(params?: any) {
		return await httpPost<any>('api/v1/admin/staff', params)
	}
	async update(params?: any) {
		const { id, ...body } = params || {}
		return await httpPatch<any>(`api/v1/admin/staff/${params?.id}`, body)
	}
	async detail(id: string) {
		return await httpGet<any>(`api/v1/admin/staff/${id}`)
	}
	async delete(id: string) {
		return await httpDelete<any>(`api/v1/admin/staff/${id}`)
	}
	async autocomplete(
		q: string,
	): Promise<{ id: string; name: string; nameKh?: string; photoUrl?: string }[]> {
		const res: any = await httpGet<any>('api/v1/admin/staff/autocomplete', { q })
		const raw = res?.data ?? res
		return Array.isArray(raw) ? raw : []
	}
	async uploadPhoto(staffId: string, formData: FormData) {
		// Use the admin endpoint to upload photos for any staff member
		return await httpPatch<any>(`api/v1/admin/staff/${staffId}/photo`, formData, {
			'Content-Type': 'multipart/form-data',
		})
	}
	async massEdit(payload: { staffIds: string[]; fields: Record<string, any> }) {
		return await httpPatch<any>('api/v1/admin/staff/mass-edit', payload)
	}
	async duplicateScan() {
		return await httpGet<any>('api/v1/admin/staff/duplicate-scan')
	}
	async mergeStaff(payload: {
		keepStaffId: string
		removeStaffId: string
		mergedFields?: Record<string, any>
	}) {
		return await httpPost<any>('api/v1/admin/staff/merge', payload)
	}
}
const staffService = new StaffService()
export { staffService }
